import { Colors } from "../../styles/theme";

const styles = {
  Footer_container: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#E8EEF6",
    px: { xs: 2.5, sm: 4, md: 5.5 },
    py: { xs: 4, sm: 5, md: 4 },
  },
  Footer_grid: {
    width: "100%",
    maxWidth: { xs: 620, lg: "none" },
    mx: "auto",
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(2, minmax(0, 1fr))",
      sm: "repeat(3, minmax(0, 1fr))",
      md: "repeat(3, minmax(0, 1fr))",
      lg: "minmax(260px, 1.4fr) repeat(3, minmax(150px, 1fr))",
    },
    columnGap: { xs: 2, sm: 3, lg: 7 },
    rowGap: { xs: 3, sm: 4, lg: 7 },
    alignItems: "start",
    "@media (min-width:480px) and (max-width:599.95px)": {
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    },
  },
  Footer_brand: {
    width: "100%",
    maxWidth: { xs: 560, lg: "340px" },
    gridColumn: { xs: "1 / -1", lg: "auto" },
    display: { xs: "flex", lg: "block" },
    flexDirection: "column",
    alignItems: "center",
    "@media (min-width:480px) and (max-width:1199.95px)": {
      maxWidth: "600px",
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      alignItems: "start",
      gap: 3,
      gridColumn: "1 / -1",
    },
  },
  Footer_logoContainer: {
    width: "fit-content",
    maxWidth: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: { xs: "center", lg: "flex-start" },
    backgroundColor: "transparent",
  },
  Footer_logo: {
    display: "block",
    width: { xs: 230, sm: 270 },
    maxWidth: "100%",
    height: "auto",
  },
  Footer_description: {
    width: { xs: "min(100%, 420px)", sm: "min(100%, 520px)" },
    maxWidth: "100%",
    mt: 2,
    color: Colors.text,
    fontSize: { xs: "0.9rem", sm: "0.95rem" },
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: 1.65,
    textAlign: { xs: "center", lg: "start" },
    "@media (min-width:480px) and (max-width:1199.95px)": {
      width: "100%",
      mt: 0,
      textAlign: "start",
    },
  },
  Footer_linksHeader: {
    mb: 1.75,
    color: Colors.navy,
    fontSize: { xs: "1rem", md: "1.05rem" },
    fontWeight: 800,
    letterSpacing: 0,
    lineHeight: 1.25,
    overflowWrap: "anywhere",
  },
  Footer_navColumn: {
    minWidth: 0,
  },
  Footer_companyColumn: {
    gridColumn: "1 / -1",
    "@media (min-width:480px)": {
      gridColumn: "auto",
    },
  },
  Footer_links: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 1.5,
  },
  Footer_companyLinks: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    columnGap: 2,
    "@media (min-width:480px)": {
      display: "flex",
      gridTemplateColumns: "none",
    },
  },
  Footer_linkStyle: {
    color: Colors.text,
    fontSize: { xs: "0.9rem", md: "0.95rem" },
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: 1.35,
    overflowWrap: "anywhere",
    textDecoration: "none",
    transition: "color 160ms ease",
    "&:hover": {
      color: Colors.primary,
      textDecoration: "none",
    },
  },
  Footer_divider: {
    width: "100%",
    height: "1px",
    mt: { xs: 4, sm: 5 },
    backgroundColor: "#C4D0DF",
  },
  Footer_socialLinks: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    pt: 2.5,
  },
  Footer_socialLink: {
    width: 40,
    height: 40,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: Colors.primary,
    borderRadius: "8px",
    transition: "color 160ms ease, background-color 160ms ease",
    "&:hover": {
      color: Colors.navy,
      backgroundColor: "rgba(47, 84, 150, 0.1)",
    },
  },
  Footer_authContainer: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: Colors.background,
    borderTop: "1px solid #E4EBF4",
    px: { xs: 2, sm: 3 },
    py: { xs: 2, sm: 2.5 },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: { xs: 1.5, sm: 2.5 },
    flexWrap: "wrap",
  },
  Footer_authText: {
    color: Colors.text,
    fontSize: "0.85rem",
    fontWeight: 500,
    lineHeight: 1.4,
  },
  Footer_authLinks: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  Footer_authLink: {
    color: Colors.primary,
    fontSize: "0.85rem",
    fontWeight: 700,
    lineHeight: 1.4,
    textDecoration: "none",
    "&:hover": {
      color: Colors.primaryHover,
      textDecoration: "none",
    },
  },
};

export default styles;
